<template>
  <div class="line-text c-container c-container--big" data-anim="lineText">
    <h3 class="line-text__title">{{ title }}</h3>
    <span class="line-text__line"></span>
  </div>
</template>

<script>
export default {
  name: 'LineText',

  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.line-text {
  padding: 80px 0;

  &__title {
    margin-bottom: 10px;

    text-transform: uppercase;
    letter-spacing: 2px;
  }

  &__line {
    display: block;

    position: relative;
    width: 100%;
    height: 5px;
    background-color: $color-dark;
  }
}
</style>
